
export class WidgetConfigurationItemObj {
agg: string;
casiz: boolean;
cauto: boolean;
cella: string;
cmsiz: number | null;
cod: string;
cols: number;
csiz: number | null;
csty: string;
exportable: boolean | null;
fdCol: boolean;
fdvSearch: string;
fdvf: string;
fieldSettings: string;
filtExp: string;
filtHide: boolean;
filtOnEx: boolean;
fmt: string;
fullCode: string;
headColorField: string;
headInherit: boolean | null;
headSubField: string;
heada: string;
hiddenCol: boolean | null;
hsty: string;
lbl: string;
mandatory: boolean | null;
masterRowStyle: string;
mems: boolean;
moreF: string;
msty: string;
noc: boolean;
ord: number;
pgrp: string;
pin: string;
pmdexParams: string;
rdr: string;
ro: boolean;
rows: number;
sel: string;
slbl: boolean;
sord: number;
sty: string;
subField: string;
sway: string;
totAgg: string;
totAggM: string;
totFmt: string;
x: number;
y: number;
}

